
/**
 *  * JAVASCRIPT DEVELOPER DOCUMENTATION
  *
   * Enterprise is a powerful and customizable theme designed for large-scale e-commerce stores. Built
    * using Web Components, it offers a highly modular architecture that makes customization and
     * maintenance easier than ever. In addition, Enterprise is optimized for speed, ensuring that your
      * store runs as fast as possible to provide your customers with a seamless shopping experience.
       *
        * If you would like to add your own JS to Enterprise, we re…diaMatches.lg.
         *
          * To check if you're on mobile you can use:
           * !theme.mediaMatches.md
            *
             * If you want to perform some action when the breakpoint changes, you can listen for the
              * breakpoint-change event on the window object.
               *
                * Example:
                 * window.addEventListener('on:breakpoint-change', (event) => {
                  *  // your code here
                   * });
                    *
                     * =================================================================================================
                      *
                       * Have fun! - The Clean Canvas Development Team.
                        */

 
// variant metafield functionality
(function () {
  function renderVariantText(variantId) {
    const dataEl = document.getElementById('VariantTextData');
    if (!dataEl) return;

    let allVariantData = {};
    try {
      allVariantData = JSON.parse(dataEl.textContent || '{}');
    } catch (e) {
      console.error('Variant Metadata JSON parse error');
      return;
    }

    // Get the object of metafields for this specific variant
    const activeMetafields = allVariantData[String(variantId)] || {};

    // 1. Handle Scalable Elements (Hero or anywhere else)
    // Use: <div data-variant-metafield="variant_rich_text_2"></div>
    const metaElements = document.querySelectorAll('[data-variant-metafield]');
    metaElements.forEach(el => {
      const key = el.getAttribute('data-variant-metafield');
      const content = activeMetafields[key] || '';
      
      el.innerHTML = content;
      content ? el.removeAttribute('hidden') : el.setAttribute('hidden', 'true');
    });

    // 2. Handle your Original [data-variant-text] for Backward Compatibility
    // This defaults to the original 'variant_rich_text' key
    const legacyBoxes = document.querySelectorAll('[data-variant-text]:not([data-variant-metafield])');
    legacyBoxes.forEach(box => {
      const content = activeMetafields['variant_rich_text'] || '';
      box.innerHTML = content;
      content ? box.removeAttribute('hidden') : box.setAttribute('hidden', 'true');
    });

    // 3. Handle the Accordion Marker (Teleport logic)
    // Supports markers like [[variant_rich_text]] or [[variant_rich_text_2]]
    const accordions = document.querySelectorAll('.disclosure__content.rte');
    accordions.forEach(acc => {
      // Regex to find any [[key]] marker
      const markerRegex = /\[\[([a-zA-Z0-9_]+)\]\]/g;
      
      if (markerRegex.test(acc.innerHTML)) {
        acc.innerHTML = acc.innerHTML.replace(markerRegex, (match, key) => {
          const content = activeMetafields[key] || '';
          return `<div class="variant-text-in-accordion" data-variant-metafield="${key}">${content}</div>`;
        });
      }
    });
  }

  function initVariantWatcher() {
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!idInput) return;

    renderVariantText(idInput.value);

    const observer = new MutationObserver(() => renderVariantText(idInput.value));
    observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  document.addEventListener('DOMContentLoaded', initVariantWatcher);
  // Re-run if Shopify theme editor selects a different variant
  document.addEventListener('shopify:section:load', initVariantWatcher);
})();


// map image show in dropdown area
(function() {
  function teleportDimensionImage() {
    const marker = '[dimension_image_marker]';
    const hiddenImage = document.getElementById('HiddenDimensionImage');
    if (!hiddenImage) return;

    // Find all accordion content areas
    const accordions = document.querySelectorAll('.disclosure__content.rte');
    
    accordions.forEach(acc => {
      if (acc.innerHTML.includes(marker)) {
        // Replace the text marker with the actual HTML from our hidden div
        acc.innerHTML = acc.innerHTML.replace(marker, hiddenImage.innerHTML);
        // Remove the hidden source to keep the DOM clean
        hiddenImage.remove(); 
      }
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', teleportDimensionImage);
  } else {
    teleportDimensionImage();
  }
})();

// header open 
document.addEventListener('DOMContentLoaded', function () {
  function openFirstChildInParent(parentDetail) {
    const navMenus = parentDetail.querySelectorAll('nav-menu details');
    
    if (navMenus.length > 0) {
      navMenus.forEach(function (navMenu) {
        navMenu.removeAttribute('open');
        const summary = navMenu.querySelector('summary');
        if (summary) {
          summary.classList.remove('is-visible');
        }
      });

      navMenus[0].setAttribute('open', '');
      const summary = navMenus[0].querySelector('summary');
      if (summary) {
        summary.classList.add('is-visible');
      }
    }
  }

  function initMobileNav() {
    if (window.innerWidth <= 768) {
      const parentDetails = document.querySelectorAll('.main-nav > li > details');

      parentDetails.forEach(function (parentDetail) {
        if (!parentDetail.dataset.mobileToggleSet) {
          parentDetail.addEventListener('toggle', function () {
            if (window.innerWidth <= 768 && parentDetail.hasAttribute('open')) {
              openFirstChildInParent(parentDetail);
            }
          });
          parentDetail.dataset.mobileToggleSet = 'true';
        }

        openFirstChildInParent(parentDetail);
      });
    }
  }

  initMobileNav();

  const menuToggle = document.querySelector('.main-menu__toggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      setTimeout(initMobileNav, 50);
    });
  }
});

// contact form class
document.querySelectorAll('.contact-page-form .input').forEach(input => {
  const toggleLabel = () => {
    const parent = input.closest('.col-span-2');
    if (input.value && input.value.trim() !== '') {
      parent.classList.add('has-value');
    } else {
      parent.classList.remove('has-value');
    }
  };

  input.addEventListener('change', toggleLabel);
  input.addEventListener('input', toggleLabel);

  toggleLabel();
});

// Open Usercentrics CMP Layer when clicking on a link that contains `#reopenBanner` in its href attribute.
(function() {
  document.querySelectorAll('a[href*="#reopenBanner"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault()

      window.UC_UI?.showSecondLayer?.()
    })
  })
})()